<template>
  <ExpandedSideSection
    :loading="isLoadingPreview"
    :no-data="false"
    :back-route="backRoute"
    empty-text="No email preview found"
  >
    <template #header-actions>
      <h2 v-if="isSent" class="text-lg font-semibold text-lime-500 flex items-center">
        <CheckCircle class="w-6 h-6 mr-2" /> Email sent successfully
      </h2>
    </template>
    <ReferralEmailContent
      :application-id="applicationId"
      :all-applications="allApplications"
    />
  </ExpandedSideSection>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CheckCircle } from 'lucide-vue-next'
import { useApplicationsStore } from '@/stores/applications'
import { useRoute } from 'vue-router'
import ExpandedSideSection from '@/components/common/ExpandedSideSection.vue'
import ReferralEmailContent from '@/components/referrals/ReferralEmailContent.vue'

const applicationsStore = useApplicationsStore()
const route = useRoute()

const props = defineProps<{
  applicationId: string
  allApplications: boolean
}>()

const isLoadingPreview = computed(() => applicationsStore.isLoadingSelected)
const isSent = computed(() => false) // This will be managed internally by ReferralEmailContent

const backRoute = computed(() => {
  if (props.allApplications) {
    const applicationId = route.params.application_id || props.applicationId
    return {
      name: 'All Applications Expanded Application',
      params: { application_id: applicationId },
      query: { ...route.query }
    }
  } else {
    // Check if we have role_id in the current route
    if (route.params.role_id) {
      const applicationId = route.params.application_id || props.applicationId
      return {
        name: 'Job Application container',
        params: {
          role_id: route.params.role_id,
          application_id: applicationId
        },
        query: { ...route.query }
      }
    } else {
      // When used in modal context, check if we have user id for applicant view
      if (route.params.id) {
        return {
          name: 'Applicant Profile with Role',
          params: {
            id: route.params.id,
            role_id: route.params.role_id || 'unknown'
          },
          query: { ...route.query }
        }
      } else {
        // Fallback to jobs list
        return { name: 'All jobs', query: { ...route.query } }
      }
    }
  }
})
</script>

